import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export interface RequestApiAccessResponse {
  message: string;
}

export const requestApiAccess = async (
  token: string,
  t: (key: string) => string
): Promise<RequestApiAccessResponse> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/User/RequestApiAccess`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to submit API access request");
    }

    const data: RequestApiAccessResponse = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};